import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef, useEffect } from "react"
import classnames from "classnames"
import apiResponse from "../../../../services/apiResponse"
import { Link } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input,
    Label,
    Modal,ModalBody,ModalFooter, ModalHeader,
    Spinner
} from "reactstrap"

import IndexBloc from "./Blocs/IndexBloc"

import Select from "react-select"
import CustomSelect from "../../../../helpers/ui/CustomSelect"
import moment from "moment"

import TableProcessComponent from './Components/TableProcessComponent'
import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar"

const createMonthOptions = () => {
    var months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];

    return months.map(function(month, i) {
        var newObj = {};
        newObj["label"] = month;
        newObj["value"] = ++i;

        return newObj;
    });
}

const IndexView = (props) => {
  
    let indexBloc = new IndexBloc();

    const [activeTab, setactiveTab] = useState("1")    
    const ppiRef = useRef(); 
    const rankRef = useRef(); 

    // Select
    const [optionMonths, setOptionMonth] = useState(createMonthOptions());

    const [selectedMonth, setSelectedMonth] = useState(moment().format('M'))
    const [year, setYear] = useState(new Date().getFullYear())
    
    useEffect( () => {
       console.log('mount')

        return () => {
            console.log('unmount');
        }
    }, [])

    let additionalFilter = {
        month: selectedMonth || "",
        year: year || "",
    };

    const reloadPPIRef = () => ppiRef.current.setTokenAPI()
    const reloadRankRef = () => rankRef.current.setTokenAPI()

    function handleButtonSearch() {
      reloadPPIRef()
      reloadRankRef()
    }

    function handleButtonReset() {
      setSelectedMonth(null)

      setTimeout(function() {
        reloadPPIRef()
        reloadRankRef()
      }, 100);
    }
    
    function toggle(tab) {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>

                    <Col xs="12">

                        <PegawaiSideBar active="riwayathukuman" />

                        <Card className="pegawai-rightbar">
                            <CardBody>
                                {/* <div className="float-end">
                                {
                                    (accessRole('create')) ?
                                        <Button 
                                          color="success" 
                                          onClick={() => handleButtonExport()}
                                        >Export</Button>
                                    : null
                                }
                                </div> */}
                                <CardTitle>Data Hukuman Disiplin</CardTitle>
                                {/* <CardSubtitle className="mb-3">
                                    Flexible Report
                                </CardSubtitle> */}
                                <hr />
          
                                <TableProcessComponent ref={ppiRef} additionalFilter={additionalFilter}/>
                                
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

        </Fragment>
    )
}

export default IndexView